import React from 'react'
import styled from 'styled-components'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import Tooltip from 'material-ui/Tooltip'
import { get } from 'lodash'
import { connect } from 'react-redux'
import * as firebase from '../actions/auth'
import Button from 'components/Button'
import { withStyles } from 'material-ui/styles'
import compose from 'recompose/compose'

const Container = styled(Paper)`
  max-width: 100vw;
  width: 600px;
  box-sizing: border-box;
  margin: 4em auto;
  padding: 2em;
  text-align: center;
`
const styles = {
  providers: {
    marginTop: 20,
  },
}

class Login extends React.Component {
  render() {
    const { error, classes, googleAuth, facebookAuth, twitterAuth } = this.props
    return (
      <Container>
        <Typography gutterBottom type="display2">
          Login
        </Typography>
        <Typography gutterBottom type="headline">
          Subscribe if you want to retrieve them later and on another computer.
        </Typography>
        <div className={classes.providers}>
          <Button onClick={googleAuth}>
            <i className="fa fa-google" />
          </Button>
          <Button onClick={facebookAuth}>
            <i className="fa fa-facebook" />
          </Button>
          <Tooltip title="coming soon" placement="bottom">
            <span>
              <Button disabled onClick={twitterAuth}>
                <i className="fa fa-twitter" />
              </Button>
            </span>
          </Tooltip>
          <Tooltip title="coming soon" placement="bottom">
            <span>
              <Button disabled>
                <i className="fa fa-linkedin" />
              </Button>
            </span>
          </Tooltip>
        </div>
        <Typography color="error">{error}</Typography>
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  error: get(state.auth, 'error.message'),
})
const mapDispatchToProps = dispatch => ({
  googleAuth: () => dispatch(firebase.googleAuth()),
  facebookAuth: () => dispatch(firebase.facebookAuth()),
  twitterAuth: () => dispatch(firebase.twitterAuth()),
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js